import { useContext, useState, useImperativeHandle, useEffect, useRef } from 'react'
import TContext from '../context'
import { Popup, Button, Toast, Cell, Picker, Input, Icon, Radio, InputNumber } from '@nutui/nutui-react';
import http, { uploadFile, isWeChatBrowserOrMiniProgram, wxAppid } from '../../../lib/http';
import { useSearchParams } from "react-router-dom";
import * as apis from '../../../lib/apis'
import styled from "styled-components";
import { useLocation, useParams } from "react-router-dom";

export const Height = 44
export const Bottom = 10

// 货币符号
const CURRENCY_SYMBOL = '$'

interface Props {
    action?: any
}


export interface Action {
    setShowPrice?: (isShow: boolean) => void;
    setShowSubmitOrder?: (isShow: boolean) => void;
    confirm?: () => boolean;
    cancel?: () => void;
}

const Index = (props: Props) => {
    const params: any = useParams()

    const [pickerShow, setPickerShow] = useState(false)
    const [showBasic, setShowBasic] = useState(false);
    const [showSubmitOrder, setShowSubmitOrder] = useState(false);
    const [loadingTxt, setLoadingTxt] = useState<string>("提交订单")
    const tc = useContext(TContext)
    const [cartNum, setCartNum] = useState(1)
    const [threeDUrl, setThreeDUrl] = useState<any>({})
    const [designerPack, setDesignerPack] = useState<any>([])
    const [designerWorkmanship, setDesignerWorkmanship] = useState<any>([])
    const [designerSite, setDesignerSite] = useState<any>([])
    const [searchParams] = useSearchParams();
    const product_id = searchParams.get("product_id");

    // 初始化状态，每个属性选中第一个
    const getInitialValues = () => {
        if (!tc?.detailAllData?.product_info?.productAttr?.length) {
            return {};
        }
        return tc.detailAllData.product_info.productAttr.reduce((acc: Record<string, string>, attr: any) => {
            // 如果有默认值，优先使用默认值，否则使用第一个值
            const defaultValue = attr.attr_value?.find((v: any) => v.check)?.attr
                || attr.attr_value?.[0]?.attr
                || '';
            acc[attr.attr_name] = defaultValue;
            return acc;
        }, {} as Record<string, string>);
    };

    const [selectedValues, setSelectedValues] = useState<Record<string, string>>(getInitialValues());
    // 选中的包装字符串
    const [selectedPack, setSelectedPack] = useState<string>('');
    // 选中的工艺字符串
    const [selectedWorkmanship, setSelectedWorkmanship] = useState<string>('');
    // 选中的对象
    const [packObj, setPackObj] = useState<any>({})
    const [workmanshipObj, setWorkmanshipObj] = useState<any>({})
    const [sizeQuantities, setSizeQuantities] = useState<Array<{ name: string, num: number }>>([]);
    // 选中的模型部位（多选）
    const [selectedParts, setSelectedParts] = useState<Set<string>>(new Set());
    // 库存
    const [inventory, setInventory] = useState<number>(0)

    // 初始化：默认选中已定制的部位
    useEffect(() => {
        if (tc?.notEmptyCodes && tc?.notEmptyCodes.length > 0) {
            setSelectedParts(new Set(tc.notEmptyCodes));
        }
    }, [tc?.notEmptyCodes]);

    // 当产品数据变化时，更新规格初始值（支持默认规格）
    useEffect(() => {
        const newValues = getInitialValues();
        if (Object.keys(newValues).length > 0) {
            setSelectedValues(newValues);
        }
    }, [tc?.detailAllData?.product_info?.productAttr]);

    useEffect(() => {
        // 当裁片切换时重置状态
        if (tc?.detailAllData?.product_info?.productAttr?.length) {
            const defaults = tc.detailAllData.product_info.productAttr.reduce((acc: Record<string, string>, attr: any) => {
                // 优先使用默认值（check为true的），否则使用第一个值
                const defaultValue = attr.attr_value?.find((v: any) => v.check)?.attr
                    || attr.attr_value?.[0]?.attr
                    || '';
                acc[attr.attr_name] = defaultValue;
                return acc;
            }, {} as Record<string, string>);
            setSelectedValues(defaults);
        } else {
            // 如果没有规格属性，清空选中值
            setSelectedValues({});
        }
        setCartNum(1);
    }, [tc?.curCutpartCode, tc?.detailAllData?.product_info?.productAttr]);
    const handleChange = (attrName: string, value: string) => {
        setSelectedValues(prev => ({
            ...prev,
            [attrName]: value,
        }));
    };

    // 根据选中的规格获取匹配的产品信息
    const getMatchedProduct = () => {
        const productValue = tc?.detailAllData?.product_info?.productValue;
        const productAttr = tc?.detailAllData?.product_info?.productAttr;
        if (!productValue) {
            return null;
        }

        // 如果没有规格属性，直接返回第一个产品值（支持默认规格）
        if (!productAttr || productAttr.length === 0) {
            const firstKey = Object.keys(productValue)[0];
            return firstKey ? productValue[firstKey] as any : null;
        }

        // 按照 productAttr 的顺序获取选中的规格值
        const selectedValuesArray: string[] = productAttr.map((attr: any) => {
            const selectedValue = selectedValues[attr.attr_name];
            // 如果没有选中值，使用第一个默认值
            return selectedValue || attr.attr_value?.[0]?.attr || '';
        }).filter((item: string) => Boolean(item)); // 过滤空值

        // 如果规格没有全部选择，返回null
        if (selectedValuesArray.length !== productAttr.length) {
            return null;
        }

        // 组合成规格字符串（按照 productAttr 的顺序）
        const selectedObj = selectedValuesArray.join(',');

        // 直接查找匹配的key
        if (productValue[selectedObj]) {
            return productValue[selectedObj] as any;
        }

        // 如果只有一个规格值（如"默认"），直接查找
        if (selectedValuesArray.length === 1) {
            const singleValue = selectedValuesArray[0];
            if (productValue[singleValue]) {
                return productValue[singleValue] as any;
            }
        }

        // 如果直接匹配失败，使用集合比较（兼容顺序不同的情况）
        const selectedSet = new Set(selectedObj.split(',').map(item => item.trim()));
        for (const [key, product] of Object.entries(productValue)) {
            const keySet = new Set(key.split(',').map(item => item.trim()));
            const setsEqual = (a: any, b: any) =>
                a.size === b.size && [...a].every(item => b.has(item));
            if (setsEqual(selectedSet, keySet)) {
                return product as any;
            }
        }
        return null;
    };
    // 设置默认值
    useEffect(() => {
        if (designerPack.length > 0 && !selectedPack) {
            setSelectedPack(designerPack[0]?.name || '');
            setPackObj(designerPack[0]);
        }
    }, [designerPack, selectedPack]);

    const designerPackChange = (selectedValue: string) => {
        const selectedItem = designerPack.find((item: any) => item.name === selectedValue);
        console.log('选中的包装对象:', selectedItem);
        console.log('包装价格:', selectedItem?.price);
        setSelectedPack(selectedValue);
        setPackObj(selectedItem);

    };
    useEffect(() => {
        if (designerWorkmanship.length > 0 && !selectedWorkmanship) {
            setSelectedWorkmanship(designerWorkmanship[0]?.name || '');
            setWorkmanshipObj(designerWorkmanship[0]);
        }
    }, [designerWorkmanship, selectedWorkmanship]);

    const designerWorkmanshipChange = (selectedValue: string) => {
        // 找到选中的完整对象
        const selectedItem = designerWorkmanship.find((item: any) => item.name === selectedValue);
        console.log('选中的工艺对象:', selectedItem);
        console.log('工艺价格:', selectedItem?.price);
        // 更新状态
        setSelectedWorkmanship(selectedValue);
        setWorkmanshipObj(selectedItem);
    };
    useEffect(() => {
        if (designerSite && designerSite.length > 0) {
            // 初始化每个尺码的数量为0
            const initialQuantities = designerSite.map((item: any) => ({
                name: item.name,
                num: 0
            }));
            setSizeQuantities(initialQuantities);
        }
    }, [designerSite]);
    const handleQuantityChange = (sizeName: string, value: string) => {
        const numValue = parseInt(value) || 0;

        // 通过 name 找到对应的项
        const newQuantities = sizeQuantities.map(item =>
            item.name === sizeName ? { ...item, num: numValue } : item
        );

        setSizeQuantities(newQuantities);
        const total = newQuantities.reduce((acc, cur) => acc + cur.num, 0);
        setCartNum(total); // 直接使用总和，不设置最小值

    };


    const setShowPrice = (isShow: boolean) => {
        setShowBasic(isShow)
    }

    useImperativeHandle(props.action, () => ({
        setShowPrice,
        setShowSubmitOrder
    }));

    useEffect(() => {
        http.get(`/api/basic_config`).then((res: any) => {
            setThreeDUrl(res?.diy_url || {})
            setDesignerPack(res?.designer_pack || [])
            setDesignerWorkmanship(res?.designer_workmanship || [])
            setDesignerSite(res?.designer_site || [])
        })
        const clickDom = () => {
            setPickerShow(false)
        }
        document.addEventListener("click", clickDom)
        return () => {
            document.removeEventListener("click", clickDom)
        }
    }, [])



    // 计算模型部位单价（多选，累加所有选中的部位价格）
    // 使用 notEmptyCodes（已定制的部位）来计算价格
    const getPartUnitPrice = (): number => {
        let partPrice = 0;
        if (tc?.detailData?.model_materials?.cutparts && tc?.notEmptyCodes) {
            tc.notEmptyCodes.forEach((code: string) => {
                const part = tc.detailData.model_materials.cutparts.find((p: any) => p.code === code);
                if (part && part.price) {
                    partPrice += parseFloat(part.price || 0);
                }
            });
        }
        return partPrice;
    };

    //计算价钱
    const cPrice = (num = 1): any => {
        const matchedProduct = getMatchedProduct();
        const specPrice = matchedProduct?.price
            ? parseFloat(matchedProduct.price)
            : parseFloat((tc?.detailData?.product_info?.price) || '0');

        const partPrice = getPartUnitPrice();

        const getWorkmanshipPrice = (): number => {
            if (!workmanshipObj?.price) return 0;
            const price = workmanshipObj.price;
            // 如果是数字，直接返回
            if (typeof price === 'number') return price;
            // 如果是字符串，提取数字部分
            const priceStr = String(price).trim();
            // 移除所有非数字和小数点的字符，然后解析
            const numStr = priceStr.replace(/[^\d.]/g, '');
            const parsed = parseFloat(numStr);
            return isNaN(parsed) ? 0 : parsed;
        };
        const workmanshipPrice = getWorkmanshipPrice();

        const getPackPrice = (): number => {
            if (!packObj?.price) return 0;
            const price = packObj.price;
            // 如果是数字，直接返回
            if (typeof price === 'number') return price;
            // 如果是字符串，提取数字部分
            const priceStr = String(price).trim();
            // 移除所有非数字和小数点的字符，然后解析
            const numStr = priceStr.replace(/[^\d.]/g, '');
            const parsed = parseFloat(numStr);
            return isNaN(parsed) ? 0 : parsed;
        };
        const packPrice = getPackPrice();

        // 总单价 = 规格价格 + 模型部位价格 + 工艺价格（材质价格）+ 包装价格
        const unitPrice = specPrice + partPrice + workmanshipPrice + packPrice;

        let frushPrice = 0
        let cutArr = []
        if (tc?.notEmptyCodes) {
            for (let i = 0; i < tc?.notEmptyCodes?.length; i++) {
                let code = tc?.notEmptyCodes[i]
                let f = tc?.detailData?.model_materials?.cutparts?.find((v: any) => v.code === code)
                if (f) {
                    frushPrice += parseFloat(f.price || 0)
                    cutArr.push(f)
                }
            }
        }

        const totalPrice = unitPrice * num
        return [<span>{CURRENCY_SYMBOL} {totalPrice.toFixed(2)}</span>, cutArr, frushPrice, totalPrice, unitPrice, specPrice]
    }

    // 切换模型部位选中状态（多选）
    const togglePart = (code: string) => {
        setSelectedParts(prev => {
            const newSet = new Set(prev);
            if (newSet.has(code)) {
                newSet.delete(code);
            } else {
                newSet.add(code);
            }
            return newSet;
        });
    };

    const sleep = (t: number) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null)
            }, t)
        })
    }

    // //生成并上传效果图
    // const makeAndUploadImage = async (onProgress: any) => {
    //     //停止3D与2D的更新
    //     tc?.threeClient?.stopNeedsUpdate()
    //     const data: any = { effect_img: [], cutpart_img: [] }
    //     let daaui = await http.get(`${apis.GET_OSS_UPLOAD_CONFIG}`)
    //     for (let i = 0; i < tc?.detailData?.model_materials?.cutparts?.length; i++) {
    //         let item = tc?.detailData?.model_materials?.cutparts[i]
    //         if (item.camera) {
    //             tc?.threeClient?.setCamera(item.camera.x, item.camera.y, item.camera.z)
    //         }
    //         await sleep(300)
    //         //获取blob
    //         const blob = await tc?.threeClient?.screePhoto()
    //         //上传效果图
    //         // const ossData: any = await uploadFile(apis.UPLOAD_IMAGE, blob)
    //         // console.log(daaui)
    //         const ossData: any = await upsuess(daaui, blob)
    //         if (!ossData) {
    //             Toast.fail(t("资源文件上传失败"))
    //             return
    //         }
    //         data.effect_img.push({
    //             code: item.code,
    //             img: ossData
    //         })
    //         onProgress(i / (tc?.detailData?.model_materials?.cutparts?.length - 1) * 100)
    //     }

    //     return data
    // }
    const makeAndUploadImage = async (onProgress: any) => {
        // 停止3D与2D的更新
        tc?.threeClient?.stopNeedsUpdate();
        const data: any = { effect_img: [], cutpart_img: [] };
        let daaui = await http.get(`${apis.GET_OSS_UPLOAD_CONFIG}`);

        // 收集上传任务
        const uploadTasks = [];

        for (let i = 0; i < tc?.detailData?.model_materials?.cutparts?.length; i++) {
            let item = tc?.detailData?.model_materials?.cutparts[i];
            //创建Promise
            const uploadTask = (async () => {
                if (item.camera) {
                    tc?.threeClient?.setCamera(item.camera.x, item.camera.y, item.camera.z);
                }
                await sleep(300);
                // 获取blob
                const blob = await tc?.threeClient?.screePhoto();
                // 上传图片
                const ossData = await upsuess(daaui, blob);
                if (!ossData) {
                    throw new Error(`上传 ${item.code} 失败`);
                }
                return {
                    code: item.code,
                    img: ossData
                };
            })();
            uploadTasks.push(uploadTask);
        }
        try {
            const results = await Promise.all(uploadTasks);

            // 收集结果
            results.forEach((result, index) => {
                data.effect_img.push(result);
                onProgress((index + 1) / tc?.detailData?.model_materials?.cutparts?.length * 100);
            });

        } catch (error) {
            Toast.fail(t("资源文件上传失败"));
            console.error("上传失败:", error);
            return null;
        }

        return data;
    };
    const upsuess = async (daaui: any, blob: any) => {
        const fileName = 'file_' + Date.now() + '.png';
        const key = daaui?.dir + fileName;
        var aliFormData = new FormData();
        aliFormData.append('signature', daaui?.signature);
        aliFormData.append('callback', daaui?.callback);
        aliFormData.append('OSSAccessKeyId', daaui?.accessid);
        aliFormData.append('policy', daaui?.policy);
        aliFormData.append('key', key);
        aliFormData.append('file', blob);
        try {
            await fetch(daaui?.host, { method: 'post', body: aliFormData })
            return (daaui.cdn || daaui.host) + '/' + key
        } catch (error) {
            return false
        }
    }

    //提交订单
    const submitOrder = async () => {
        Toast.loading(t("提交中"), {
            cover: true, // 是否展示透明遮罩层
            // coverColor: 'rgba(0, 0, 0, 0)', // 遮罩颜色设定
            closeOnClickOverlay: false, // 点击遮罩可关闭
            duration: 0
        })
        try {
            const mdata = await makeAndUploadImage((p: any) => {
                setLoadingTxt(p.toFixed(2) + "%")
            })
            console.log(mdata)
            //构造提交数据
            const postData: any = {
            }
            const resourceData: any = {}
            postData.pruduct_id = tc?.detailData?.id
            postData.price_str = cPrice()[3].toFixed(2)
            if (tc?.notEmptyCodes && tc?.notEmptyCodes?.length !== 0) {
                postData.printing_code = JSON.stringify(tc?.notEmptyCodes)
            }
            if (tc?.curFabric?.color) {
                postData.color = tc?.curFabric?.color
            }
            resourceData.canvas_width = tc?.fabricW as number
            resourceData.canvas_data = tc?.fabricClient?.allToJson()
            for (let i = 0; i < resourceData.canvas_data.length; i++) {
                let item = resourceData.canvas_data[i]
                let f = tc?.detailData?.model_materials?.cutparts?.find((j: any) => j.code === item.code)
                if (f) {
                    item.name = f.txt
                }
            }

            resourceData.model_url = tc?.detailData?.model_materials?.obj_url
            resourceData.map_info = tc?.curFabric
            resourceData.materials = mdata
            let daaui: any = await http.get(`${apis.GET_OSS_UPLOAD_CONFIG}`)
            const fileName = 'file_' + Date.now() + '.json';
            const key = daaui?.dir + fileName;
            var aliFormData = new FormData();
            aliFormData.append('signature', daaui?.signature);
            aliFormData.append('callback', daaui?.callback);
            aliFormData.append('OSSAccessKeyId', daaui?.accessid);
            aliFormData.append('policy', daaui?.policy);
            aliFormData.append('key', key);
            aliFormData.append('file', new Blob([JSON.stringify(resourceData)], { type: 'application/json' }));
            try {
                await fetch(daaui?.host, { method: 'post', body: aliFormData })
            } catch (error) {

            }
            const ossData: any = (daaui.cdn || daaui.host) + '/' + key
            if (!ossData) {
                Toast.fail(t("提交失败,请重试"))
                Toast.hide()
                return
            }
            try {
                postData.cover = mdata.effect_img
            } catch (error) {

            }
            postData.resource_url = ossData

            const data = {
                productId: product_id,
                cartNum: Number(cartNum),
                new: 1,
                uniqueId: getMatchedProduct()?.unique || '',
                designer_attr: {
                    cover: postData.cover,
                    resource_url: postData.resource_url,
                    pack: packObj,
                    workmanship: workmanshipObj,
                    site: sizeQuantities,
                    model_arr: tc.detailData.model_materials.cutparts.map((part: any) => {
                        const isModified = selectedParts.has(part.code);
                        return {
                            name: part.txt,
                            code: part.code,
                            status: isModified ? "1" : "0",
                            price: String(part.price || "0")
                        };
                    })

                },
                // virtual_type: tc?.detailData.virtual_type,
            }
            console.log(data, "data")
            http.post(`${apis.CART_ADD}`, data).then((res: any) => {
                Toast.success(t("操作成功"))
                setShowBasic(false)
                setLoadingTxt(t("提交订单"))
                // window.opener.postMessage({
                //     type: 'ORDER_COMPLETED',
                //     cartId: res.cartId,
                //     cover: postData.cover,
                //     resource_url: postData.resource_url,
                //     timestamp: Date.now()
                // }, '*');
                // 使用 replace 跳转回原页面
                // let url = `http://192.168.0.24:50923/order_confirm?new=1&cartId=${res.cartId}&cover=${postData.cover}&resource_url=${postData.resource_url}`
                // &cover=${postData.cover}&resource_url=${postData.resource_url}
                let url = `${process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:50923' : threeDUrl}/order_confirm?new=1&cartId=${res.cartId}`
                window.location.replace(url)
            })

        } catch (error) {
            console.error(error)
            Toast.fail(t("提交失败,请重试"))
            setLoadingTxt(t("提交订单"))
        }
        Toast.hide()

    }

    const optionDataHandle = () => {
        const arr = []
        for (let i = 0; i < tc.detailData?.model_materials?.cutparts?.length; i++) {
            let item = tc.detailData?.model_materials?.cutparts[i]
            arr.push({ text: item.txt, value: item.code })
        }
        if (!tc.curCutpartCode) {
            return []
        }
        return arr
    }

    const cutpartOptions = optionDataHandle()
    const getOptionTxt = (code: any) => {
        const f = cutpartOptions.find(v => v.value === code)
        if (f) {
            return t(f.text)
        }
        return ""
    }
    const productAttrs = tc?.detailAllData?.product_info?.productAttr;
    const shouldShow = showSubmitOrder && productAttrs?.length;
    // const showPackaging = designerPack;
    return (
        <div style={{
            bottom: (tc?.menuHeight as number + Bottom) || 0,
            width: "100%",
            lineHeight: Height + 'px',
            height: Height
        }}>
            {/* <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 20px"
            }}>
                {product_id ? (
                    <div>
                        <div onClick={() => {
                            setShowBasic(true);
                            setShowSubmitOrder(false)
                        }} style={{
                            color: "rgb(24, 144, 255)",
                            cursor: 'pointer'
                        }}><span style={{
                            fontWeight: 600,
                            fontSize: 14
                        }}>{cPrice()[0]}</span>
                            <span style={{
                                fontSize: 12, marginLeft: 10
                            }}>{t('查看明细')}</span>
                        </div>
                    </div>
                ) : null
                }
            </div> */}
            <Popup
                visible={showBasic}
                teleport={document.body}
                overlayStyle={{ zIndex: 13, background: 'rgba(0, 0, 0, 0.5)' }}
                closeable={false}
                style={{
                    width: '75vw',
                    maxWidth: '1100px',
                    maxHeight: '90vh',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                }}
                position="center"
                closeOnClickOverlay={false}
                onClose={() => {
                    setShowBasic(false)
                }}
            >
                <style>{`
                    .nut-radio-button--active {
                        background: rgb(72, 85, 99) !important;
                        border-color: rgb(72, 85, 99) !important;
                        color: #fff !important;
                    }
                    .nut-radio-button {
                        color: rgb(72, 85, 99);
                        border-color: #ddd;
                        transition: all 0.2s;
                        padding: 8px 16px;
                        border-radius: 4px;
                    }
                    .nut-radio-button:hover {
                        border-color: rgb(24, 144, 255);
                        color: rgb(24, 144, 255);
                    }
                    .modal-container::-webkit-scrollbar {
                        display: none;
                        width: 0;
                        height: 0;
                    }
                    .modal-container {
                        -ms-overflow-style: none;
                        scrollbar-width: none;
                    }
                `}</style>
                <ModalContainer>
                    <ModalHeader>
                        <ModalTitle>{t(showSubmitOrder ? "下单" : "价格明细")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        {/* 0. 模型部位 */}
                        {tc?.detailData?.model_materials?.cutparts?.length > 0 && (
                            <Section>
                                <SectionTitle>{t('模型部位')}</SectionTitle>
                                <OptionGroup>
                                    {tc.detailData.model_materials.cutparts.map((part: any) => {
                                        const isSelected = selectedParts.has(part.code);
                                        const hasPrice = part.price !== 0 &&
                                            part.price !== null &&
                                            part.price !== undefined &&
                                            parseFloat(part.price || 0) > 0;
                                        return (
                                            <OptionItem
                                                key={part.code}
                                                className={isSelected ? 'selected' : ''}
                                                style={{
                                                    cursor: 'default',
                                                    pointerEvents: 'none',
                                                    opacity: isSelected ? 1 : 0.5
                                                }}
                                            >
                                                {t(part.txt || part.code)}
                                                {hasPrice && (
                                                    <OptionPrice>+{CURRENCY_SYMBOL}{parseFloat(part.price || 0).toFixed(2)}</OptionPrice>
                                                )}
                                            </OptionItem>
                                        );
                                    })}
                                </OptionGroup>
                                {/* 已定制部位显示 */}
                                {tc?.notEmptyCodes && tc.notEmptyCodes.length > 0 && (
                                    <SelectedSpecs>
                                        <div>
                                            <SelectedSpecsText>{t('已定制部位')}：</SelectedSpecsText>
                                            <SelectedSpecsValue>
                                                {tc.notEmptyCodes.map((code: string) => {
                                                    const part = tc.detailData?.model_materials?.cutparts?.find((p: any) => p.code === code);
                                                    return part ? t(part.txt || part.code) : code;
                                                }).join(' / ') || '-'}
                                            </SelectedSpecsValue>
                                        </div>
                                        <div>
                                            <SelectedSpecsText>{t('价格')}：</SelectedSpecsText>
                                            <SelectedSpecsPrice>
                                                {CURRENCY_SYMBOL}{getPartUnitPrice().toFixed(2)}
                                            </SelectedSpecsPrice>
                                        </div>
                                    </SelectedSpecs>
                                )}
                            </Section>
                        )}

                        {/* 1. 规格 */}
                        {shouldShow ? (
                            <Section>
                                <SectionTitle>
                                    {t('规格')}
                                    <small style={{ marginLeft: '8px', color: '#666', fontWeight: 'normal' }}>
                                        ({t('库存')}: {getMatchedProduct()?.stock || 0})
                                    </small>
                                </SectionTitle>
                                <div id="specContainer">
                                    {productAttrs.map((attr: any, index: number) => (
                                        <SpecItem key={index}>
                                            <SpecItemTitle>{t(attr?.attr_name || '')}</SpecItemTitle>
                                            <OptionGroup>
                                                {attr?.attr_value?.map((v: any) => {
                                                    const isSelected = selectedValues[attr.attr_name] === v.attr;
                                                    return (
                                                        <OptionItem
                                                            key={v?.attr}
                                                            className={isSelected ? 'selected' : ''}
                                                            onClick={() => handleChange(attr?.attr_name || '', v?.attr || '')}
                                                        >
                                                            {t(v?.attr || '')}
                                                        </OptionItem>
                                                    );
                                                })}
                                            </OptionGroup>
                                        </SpecItem>
                                    ))}
                                </div>
                                {/* 已选规格显示 */}
                                {Object.keys(selectedValues).length > 0 && (
                                    <SelectedSpecs>
                                        <div>
                                            <SelectedSpecsText>{t('已选规格')}：</SelectedSpecsText>
                                            <SelectedSpecsValue>
                                                {productAttrs
                                                    .map((attr: any) => selectedValues[attr.attr_name])
                                                    .filter(Boolean)
                                                    .join(' / ') || '-'}
                                            </SelectedSpecsValue>
                                        </div>
                                        <div>
                                            <SelectedSpecsText>{t('价格')}：</SelectedSpecsText>
                                            <SelectedSpecsPrice>
                                                {CURRENCY_SYMBOL}{(() => {
                                                    const matchedProduct = getMatchedProduct();
                                                    return matchedProduct?.price
                                                        ? parseFloat(matchedProduct.price).toFixed(2)
                                                        : '0.00';
                                                })()}
                                            </SelectedSpecsPrice>
                                        </div>
                                    </SelectedSpecs>
                                )}
                            </Section>
                        ) : null}
                        {/* 2. 工艺 */}
                        {designerWorkmanship && designerWorkmanship.length > 0 ? (
                            <Section>
                                <SectionTitle>{t('工艺')}</SectionTitle>
                                <OptionGroup>
                                    {designerWorkmanship.map((item: any) => {
                                        const isSelected = selectedWorkmanship === item?.name;
                                        return (
                                            <OptionItem
                                                key={item?.name}
                                                className={isSelected ? 'selected' : ''}
                                                onClick={() => designerWorkmanshipChange(item?.name || '')}
                                            >
                                                {t(item?.name || '')}
                                                {item.price && (
                                                    <OptionPrice>+{CURRENCY_SYMBOL}{parseFloat(item.price).toFixed(2)}</OptionPrice>
                                                )}
                                            </OptionItem>
                                        );
                                    })}
                                </OptionGroup>
                            </Section>
                        ) : null}

                        {/* 3. 包装 */}
                        {designerPack && designerPack.length > 0 ? (
                            <Section>
                                <SectionTitle>{t('包装')}</SectionTitle>
                                <OptionGroup>
                                    {designerPack.map((item: any) => {
                                        const isSelected = selectedPack === item?.name;
                                        return (
                                            <OptionItem
                                                key={item?.name}
                                                className={isSelected ? 'selected' : ''}
                                                onClick={() => designerPackChange(item?.name || '')}
                                            >
                                                {t(item?.name || '')}
                                                {item.price && (
                                                    <OptionPrice>+{CURRENCY_SYMBOL}{parseFloat(item.price).toFixed(2)}</OptionPrice>
                                                )}
                                            </OptionItem>
                                        );
                                    })}
                                </OptionGroup>
                                {/* 已选材质和包装显示 */}
                                {(selectedWorkmanship || selectedPack) && (
                                    <SelectedSpecs>
                                        <div>
                                            <SelectedSpecsText>{t('材质')}：</SelectedSpecsText>
                                            <SelectedSpecsValue>
                                                {selectedWorkmanship ? t(selectedWorkmanship) : '-'}
                                            </SelectedSpecsValue>
                                            <SelectedSpecsText style={{ marginLeft: 16 }}>{t('包装')}：</SelectedSpecsText>
                                            <SelectedSpecsValue>
                                                {selectedPack ? t(selectedPack) : '-'}
                                            </SelectedSpecsValue>
                                        </div>
                                        <div>
                                            <SelectedSpecsText>{t('价格')}：</SelectedSpecsText>
                                            <SelectedSpecsPrice>
                                                {CURRENCY_SYMBOL}{(() => {
                                                    const getWorkmanshipPrice = (): number => {
                                                        if (!workmanshipObj?.price) return 0;
                                                        const price = workmanshipObj.price;
                                                        if (typeof price === 'number') return price;
                                                        const priceStr = String(price).trim();
                                                        const numStr = priceStr.replace(/[^\d.]/g, '');
                                                        const parsed = parseFloat(numStr);
                                                        return isNaN(parsed) ? 0 : parsed;
                                                    };
                                                    const getPackPrice = (): number => {
                                                        if (!packObj?.price) return 0;
                                                        const price = packObj.price;
                                                        if (typeof price === 'number') return price;
                                                        const priceStr = String(price).trim();
                                                        const numStr = priceStr.replace(/[^\d.]/g, '');
                                                        const parsed = parseFloat(numStr);
                                                        return isNaN(parsed) ? 0 : parsed;
                                                    };
                                                    const workmanshipPrice = getWorkmanshipPrice();
                                                    const packPrice = getPackPrice();
                                                    return (workmanshipPrice + packPrice).toFixed(2);
                                                })()}
                                            </SelectedSpecsPrice>
                                        </div>
                                    </SelectedSpecs>
                                )}
                            </Section>
                        ) : null}

                        {/* 4. 价格数量 */}
                        <Section>
                            <SectionTitle>{t('价格数量')}</SectionTitle>
                            {
                                (() => {
                                    const totalQuantity = sizeQuantities.reduce((acc, cur) => acc + cur.num, 0);
                                    const totalStock = getMatchedProduct()?.stock || 0;
                                    const isOverstock = totalQuantity > totalStock;
                                    return (
                                        <>
                                            <TotalQuantity style={{
                                                borderColor: isOverstock ? '#ff4d4f' : '#1890ff',
                                                backgroundColor: isOverstock ? '#fff2f0' : '#f0f7ff'
                                            }}>
                                                <TotalQuantityLabel style={{
                                                    color: isOverstock ? '#ff4d4f' : 'rgb(72, 85, 99)'
                                                }}>
                                                    {t('总数量')}
                                                    {isOverstock && ` (${t('超过库存')})`}
                                                    <small style={{ marginLeft: '8px', color: '#666', fontWeight: 'normal' }}>
                                                        ({t('库存')}: {getMatchedProduct()?.stock || 0})
                                                    </small>
                                                </TotalQuantityLabel>
                                                <TotalQuantityValue style={{
                                                    color: isOverstock ? '#ff4d4f' : 'rgb(24, 144, 255)',
                                                    fontWeight: isOverstock ? 'bold' : 'normal'
                                                }}>{sizeQuantities.reduce((acc, cur) => acc + cur.num, 0)}</TotalQuantityValue>
                                            </TotalQuantity>
                                            {/* <TotalQuantity style={{
                                                borderColor: isOverstock ? '#ff4d4f' : '#1890ff',
                                                backgroundColor: isOverstock ? '#fff2f0' : '#f0f7ff'
                                            }}>
                                                <TotalQuantityLabel style={{
                                                    color: isOverstock ? '#ff4d4f' : 'rgb(72, 85, 99)'
                                                }}>{t('总库存')}</TotalQuantityLabel>
                                                <TotalQuantityValue style={{
                                                    color: isOverstock ? '#ff4d4f' : 'rgb(24, 144, 255)',
                                                    fontWeight: isOverstock ? 'bold' : 'normal'
                                                }}>{getMatchedProduct()?.stock || 0}</TotalQuantityValue>
                                            </TotalQuantity> */}
                                        </>
                                    )
                                })()
                            }

                            {designerSite && designerSite.length > 0 ? (
                                <SizeTableContainer>
                                    <SizeTable>
                                        <thead>
                                            <tr>
                                                <th>{t('尺码')}</th>
                                                <th>{t('单价')}</th>
                                                <th>{t('数量')}</th>
                                                <th>{t('小计')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {designerSite.map((item: any) => {
                                                const quantity = sizeQuantities.find(q => q.name === item.name)?.num || 0;
                                                const unitPrice = cPrice(1)[4] || 0; // 获取总单价（包含所有费用）
                                                const subtotal = unitPrice * quantity;
                                                return (
                                                    <tr key={item.id}>
                                                        <td>{item.name}</td>
                                                        <td className="price-cell">{CURRENCY_SYMBOL}{unitPrice.toFixed(2)}</td>
                                                        <td>
                                                            <QuantityInput
                                                                type="number"
                                                                min="0"
                                                                value={quantity.toString()} // 确保是字符串
                                                                onChange={(e) => {
                                                                    const inputValue = e.target.value;
                                                                    handleQuantityChange(item.name, inputValue);
                                                                }}
                                                                onFocus={(e) => {
                                                                    // 当焦点进入时，如果是0则清空输入框
                                                                    if (e.target.value === '0') {
                                                                        e.target.value = '';
                                                                    }
                                                                }}
                                                                onBlur={(e) => {
                                                                    // 当失去焦点时，如果是空字符串则设置为0
                                                                    if (e.target.value === '') {
                                                                        e.target.value = '0';
                                                                        handleQuantityChange(item.name, '0');
                                                                    }
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    // 阻止输入负号
                                                                    if (e.key === '-' || e.key === '−') {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="price-cell">{CURRENCY_SYMBOL}{subtotal.toFixed(2)}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </SizeTable>
                                </SizeTableContainer>
                            ) : null}
                        </Section>


                        {/* 5. 价格明细 */}
                        <Section>
                            <SectionTitle>{t('价格明细')}</SectionTitle>

                            <PriceSummary>
                                {(() => {
                                    const totalQuantity = sizeQuantities.reduce((acc, cur) => acc + cur.num, 0);
                                    return (
                                        <>
                                            {totalQuantity > 0 && (
                                                <PriceRow>
                                                    <PriceLabel>{t('单价')}</PriceLabel>
                                                    <PriceValue>{CURRENCY_SYMBOL} {cPrice(1)[4].toFixed(2)}</PriceValue>
                                                </PriceRow>
                                            )}
                                            <PriceRow>
                                                <PriceLabel>{t('数量')}</PriceLabel>
                                                <PriceValue>{totalQuantity}</PriceValue>
                                            </PriceRow>
                                            {totalQuantity > 0 && (
                                                <PriceRow style={{ borderTop: 'none', marginTop: '4px', paddingTop: '10px' }}>
                                                    <PriceLabel style={{ fontSize: 16, fontWeight: 600, color: 'rgb(72, 85, 99)' }}>{t('总价')}</PriceLabel>
                                                    <PriceValue style={{ fontSize: 18, color: 'rgb(24, 144, 255)', fontWeight: 600 }}>
                                                        {CURRENCY_SYMBOL} {cPrice(totalQuantity)[3].toFixed(2)}
                                                    </PriceValue>
                                                </PriceRow>
                                            )}
                                        </>
                                    );
                                })()}
                            </PriceSummary>
                        </Section>
                    </ModalBody>

                    <ModalFooter>
                        <BtnSecondary onClick={() => setShowBasic(false)}>{t('取消')}</BtnSecondary>
                        {
                            showSubmitOrder && (() => {
                                const totalQuantity = sizeQuantities.reduce((acc, cur) => acc + cur.num, 0);
                                const totalStock = getMatchedProduct()?.stock || 0;
                                const isOverstock = totalQuantity > totalStock;
                                const isDisabled = totalQuantity === 0 || isOverstock;
                                return (
                                    <Button
                                        loading={loadingTxt !== "提交订单"}
                                        disabled={isDisabled}
                                        onClick={submitOrder}
                                        style={{
                                            background: isDisabled ? "#ccc" : "rgb(24, 144, 255)",
                                            border: isDisabled ? "1px solid #ccc" : "1px solid rgb(24, 144, 255)",
                                            borderRadius: "4px",
                                            padding: "10px 20px",
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            cursor: isDisabled ? "not-allowed" : "pointer",
                                            opacity: isDisabled ? 0.6 : 1
                                        }}
                                        type="primary"
                                    >
                                        {t(loadingTxt)}
                                    </Button>
                                );
                            })()
                        }
                    </ModalFooter>

                </ModalContainer>
            </Popup>
        </div>
    )
}

const LeftLabel = styled.div`
    color: rgb(72, 85, 99);
    font-size: 14px;
    flex-shrink: 0;
    width: 80px;
`

const CellWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 25px;
    margin-top: 12px;
`

const OptionWrapper = styled.div`
    position: absolute;
    top:50px;
    left: 10px;
    background: #FFF;
    border-radius: 5px;
    box-shadow: 1px 2px 4px #ccc;
    overflow: hidden;
`
interface OptionProps {
    $active: boolean;
}

const Option = styled.div<OptionProps>`
    font-size: 14px;
    color: ${(props: any) => props.$active ? "#FFF" : "rgb(72, 85, 99)"};
    text-align: center;
    padding: 0 15px;
    background: ${(props: any) => props.$active ? "rgb(72, 85, 99) !important" : "none"};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    word-break: keep-all;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
        background: ${(props: any) => props.$active ? "rgb(72, 85, 99)" : "rgba(72, 85, 99, 0.1)"};
    }
`

const OptionLabel = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    margin-right: 4px;
`

const ModalContainer = styled.div`
    background: #fff;
    border-radius: 4px;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    -ms-overflow-style: none;
    scrollbar-width: none;
    
    &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
    }
`

const ModalHeader = styled.div`
    padding: 20px 24px;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
`

const ModalTitle = styled.h2`
    font-size: 18px;
    font-weight: 600;
    color: rgb(72, 85, 99);
    margin: 0;
`

const ModalBody = styled.div`
    padding: 24px;
`

const Section = styled.div`
    margin-bottom: 28px;
    &:last-child {
        margin-bottom: 0;
    }
`

const SectionTitle = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: rgb(72, 85, 99);
    margin-bottom: 14px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e5e7eb;
`

const SpecItem = styled.div`
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
`

const SpecItemTitle = styled.div`
    font-size: 13px;
    font-weight: 500;
    color: rgb(72, 85, 99);
    margin-bottom: 10px;
`

const OptionGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
`

const OptionItem = styled.div`
    padding: 8px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    background: #fff;
    font-size: 14px;
    color: rgb(72, 85, 99);
    position: relative;
    user-select: none;
    
    &:hover {
        border-color: rgb(24, 144, 255);
        color: rgb(24, 144, 255);
    }
    
    &.selected {
        border-color: #1890FF;
        background:#1890FF ;
        color: #fff;
    }
    
    &.selected:hover {
        border-color: rgb(72, 85, 99);
        color: #fff;
    }
`

const OptionPrice = styled.span`
    font-size: 12px;
    color: rgb(24, 144, 255);
    margin-left: 6px;
    font-weight: 500;
    
    .selected & {
        color: rgba(255, 255, 255, 0.9);
    }
`

const SelectedSpecs = styled.div`
    background: #f0f7ff;
    border: 1px solid rgb(24, 144, 255);
    border-radius: 4px;
    padding: 12px 16px;
    margin-top: 16px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const SelectedSpecsText = styled.span`
    font-size: 14px;
    color: rgb(72, 85, 99);
`

const SelectedSpecsValue = styled.span`
    font-size: 14px;
    color: rgb(24, 144, 255);
    font-weight: 500;
    margin: 0 8px;
`

const SelectedSpecsPrice = styled.span`
    font-size: 16px;
    color: rgb(24, 144, 255);
    font-weight: 600;
`

const TotalQuantity = styled.div`
    background: #f0f7ff;
    border: 1px solid rgb(24, 144, 255);
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const TotalQuantityLabel = styled.span`
    font-size: 14px;
    color: rgb(72, 85, 99);
    font-weight: 500;
`

const TotalQuantityValue = styled.span`
    font-size: 16px;
    color: rgb(24, 144, 255);
    font-weight: 600;
`

const SizeTableContainer = styled.div`
    overflow-x: auto;
    margin-top: 16px;
`

const SizeTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    background: white;
    border: 1px solid #e5e7eb;
    thead {
        background: #f9fafb;
        color: rgb(72, 85, 99);
    }
    th {
        padding: 12px;
        text-align: center;
        font-weight: 600;
        font-size: 14px;
    }
    td {
        padding: 12px;
        text-align: center;
        border-bottom: 1px solid #e5e7eb;
        font-size: 14px;
        color: #374151;
    }
    .price-cell {
        color: rgb(24, 144, 255);
        font-weight: 500;
    }
    tbody tr:hover {
        background: #f9fafb;
    }
    tbody tr:last-child td {
        border-bottom: none;
    }
`

const QuantityInput = styled.input`
    width: 80px;
    padding: 6px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    &:focus {
        outline: none;
        border-color: rgb(24, 144, 255);
    }
`

const PriceSummary = styled.div`
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    padding: 16px 20px;
`

const PriceRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e5e7eb;
    &:last-child {
        border-bottom: none;
    }
`

const PriceLabel = styled.span`
    color: rgb(72, 85, 99);
    font-size: 14px;
`

const PriceValue = styled.span`
    color: rgb(72, 85, 99);
    font-size: 14px;
    font-weight: 500;
`

const ModalFooter = styled.div`
    padding: 16px 24px;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #fff;
`

const BtnSecondary = styled.button`
    padding: 10px 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    background: #fff;
    color: rgb(72, 85, 99);
    &:hover {
        background: #f5f5f5;
        border-color: rgb(72, 85, 99);
    }
`

const BtnPrimary = styled.button`
    padding: 10px 20px;
    border: 1px solid rgb(24, 144, 255);
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    background: rgb(24, 144, 255);
    color: #fff;
    &:hover {
        background: rgb(20, 120, 220);
        border-color: rgb(20, 120, 220);
    }
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`

export default Index
